import { useEffect, useState } from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

export default function ConsentCallback() {
  const [status, setStatus] = useState<'success' | 'error' | 'loading'>('loading');
  const [message, setMessage] = useState('');
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const adminConsent = params.get('admin_consent');
    const tenant = params.get('tenant');
    const error = params.get('error');
    const errorDescription = params.get('error_description');

    if (error) {
      setStatus('error');
      setMessage(errorDescription || error);
    } else if (adminConsent === 'True') {
      setStatus('success');
      setMessage('Admin consent was granted successfully!');

      // Notify the opener window to refresh
      if (window.opener) {
        try {
          window.opener.postMessage({ type: 'consent-complete', tenant, success: true }, '*');
        } catch (e) {
          // Ignore cross-origin errors
        }
      }
    } else {
      setStatus('success');
      setMessage('Consent process completed.');
    }
  }, []);

  // Countdown and auto-close on success
  useEffect(() => {
    if (status === 'success' && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (status === 'success' && countdown === 0) {
      window.close();
    }
  }, [status, countdown]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted">
      <div className="max-w-md w-full p-8 text-center">
        {status === 'loading' && (
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-foreground mb-2">
              Consent Granted
            </h2>
            <p className="text-muted-foreground mb-4">{message}</p>
            <p className="text-sm text-muted-foreground">
              This window will close automatically...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-foreground mb-2">
              Consent Failed
            </h2>
            <p className="text-muted-foreground mb-4">{message}</p>
            <button
              onClick={() => window.close()}
              className="btn-primary"
            >
              Close Window
            </button>
          </>
        )}
      </div>
    </div>
  );
}
